import { WifiOff, RefreshCw, CloudOff } from "lucide-react";
import { useOfflineSync } from "@/hooks/useOfflineSync";
import { useTranslation } from "react-i18next";

export function OfflineIndicator() {
  const { isOnline, isSyncing, pendingCount, syncPendingMutations } = useOfflineSync();
  const { t } = useTranslation();

  // Show nothing if online and no pending changes
  if (isOnline && pendingCount === 0 && !isSyncing) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium animate-in slide-in-from-top-2"
      style={{
        backgroundColor: isOnline ? "hsl(var(--primary))" : "hsl(var(--destructive))",
        color: isOnline ? "hsl(var(--primary-foreground))" : "hsl(var(--destructive-foreground))",
      }}
    >
      {!isOnline ? (
        <>
          <WifiOff className="h-4 w-4" />
          <span>{t("offline.youAreOffline")}</span>
          {pendingCount > 0 && (
            <span className="ml-1 rounded-full bg-white/20 px-2 py-0.5 text-xs">
              {pendingCount} {t("offline.pending")}
            </span>
          )}
        </>
      ) : isSyncing ? (
        <>
          <RefreshCw className="h-4 w-4 animate-spin" />
          <span>{t("offline.syncing")}</span>
        </>
      ) : pendingCount > 0 ? (
        <>
          <CloudOff className="h-4 w-4" />
          <span>
            {pendingCount} {t("offline.pendingChanges")}
          </span>
          <button
            onClick={syncPendingMutations}
            className="ml-2 underline text-xs hover:opacity-80"
          >
            {t("offline.syncNow")}
          </button>
        </>
      ) : null}
    </div>
  );
}
